import FItem from '.';

export default class FItemNumber extends FItem {
  constructor(props) {
    super(props);
    if (props.min || props.min === 0) {
      this.min = props.min;
      this.setValidatorMin(props.min);
    } else {
      this.min = -Infinity;
    }
    if (props.max || props.max === 0) {
      this.max = props.max;
      this.setValidatorMax(props.max);
    } else {
      this.max = Infinity;
    }
  }

  set(value = 0) {
    super.set(value);
  }

  setValidatorRequire(message = 'Обязательное') {
    this.setValidator((value) => {
      if (!Number.isInteger(value) || value === 0) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    }, true);
    return this;
  }

  setValidatorMin(num, message = 'Min') {
    this.setValidator((value) => {
      if (value < num) {
        return Promise.reject(`${message}: ${num}`);
      }
      return Promise.resolve();
    }, true);
    return this;
  }

  setValidatorMax(num, message = 'Max') {
    this.setValidator((value) => {
      if (value > num) {
        return Promise.reject(`${message}: ${num}`);
      }
      return Promise.resolve();
    }, true);
    return this;
  }
}
